module.exports = __webpack_public_path__ + "static/img/xiao.4e5150db.png";